import ArticleLayout from '@/components/feature/ArticleLayout';
import { articleBudget } from '@/mocks/articles';

export default function BudgetFindsPage() {
  return <ArticleLayout article={articleBudget} />;
}